module.exports = __webpack_public_path__ + "img/CL.f44e3c00.svg";